import { render, staticRenderFns } from "./DeleteIconButton.vue?vue&type=template&id=46f0cfd2&scoped=true&"
import script from "./DeleteIconButton.vue?vue&type=script&lang=js&"
export * from "./DeleteIconButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteIconButton.vue?vue&type=style&index=0&id=46f0cfd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0cfd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46f0cfd2', component.options)
    } else {
      api.reload('46f0cfd2', component.options)
    }
    module.hot.accept("./DeleteIconButton.vue?vue&type=template&id=46f0cfd2&scoped=true&", function () {
      api.rerender('46f0cfd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/Buttons/DeleteIconButton.vue"
export default component.exports